export default __webpack_public_path__ + "static/media/logo-text.b2b45a1b.svg";